<template>
    <div id="verify-campaign-save" class="modal inmodal fade" role="dialog" aria-hidden="true" data-backdrop="static"
         tabindex="-1">
        <div class="modal-dialog">
            <div class="modal-content animated fadeInUp">
                <div class="modal-header">
                    <button type="button" class="close" data-dismiss="modal">
                        <span aria-hidden="true"><i class="fa-regular fa-xmark"></i></span>
                        <span class="sr-only">{{ t_close }}</span>
                    </button>
                    <h2 class="modal-title">{{ t_description }}</h2>
                </div>
                <div class="modal-body text-center scrollBox" :style="'max-height: ' + maxBodyHeight + 'px;'">
                    <div class="btn btn-primary m-r-lg" @click.stop.prevent="saveAsOriginal()">
                        {{ t_save_as_original }}
                    </div>
                    <div class="btn btn-primary" @click.stop.prevent="saveAsCopy()">
                        {{ t_save_as_copy }}
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import modalMixin from "../../common/modal-mixin"

    export default {
        props: ['plan'],
        mixins: [
            modalMixin
        ],
        data() {
            return {
                t_close: Lang.langGet("Close"),
                t_description: Lang.langGet("You are updating the original campaign. Are you sure?"),
                t_save_as_original: Lang.langGet("Save As Original"),
                t_save_as_copy: Lang.langGet("Save As Copy"),
                project_id: Laravel.activeProject,

                modalName: 'verify-campaign-save'
            }
        },
        methods: {
            saveAsOriginal: function () {
                EaseEventBus.fire('saveAsOriginal');
                EaseEventBus.fire('hideModal', this.modalName);
            },
            saveAsCopy: function () {
                EaseEventBus.fire('saveAsCopy');
                EaseEventBus.fire('hideModal', this.modalName);
            }
        }
    }
</script>
